import { useEffect } from 'react';

import useMediaQuery from '@cartwhl/ui/hooks/useMediaQuery';

import { CameraButtons } from 'components/AnimationPlayer';
import { PoseFrontDoor } from 'components/FrontDoor';
import FloatPanels from 'components/PoseMode/FloatPanels';
import Footer from 'components/PoseMode/Footer';
import PoseMainPlayer from 'components/PoseMode/PoseMainPlayer';
import {
  StageLoader,
  StudioLayout,
  VideoOverlay,
} from 'components/StudioLayout';
import {
  animationPlayerStore,
  characterPickerStore,
  navigationStore,
  noticesStore,
  projectStore,
} from 'stores';

export default function Project() {
  const { projectID } = navigationStore.getRouteParams();
  const playerStore = animationPlayerStore.defaultInstance;
  const isMobile = useMediaQuery('(max-width: 640px)');

  useEffect(() => {
    console.log('PoseMode - Mount');

    // Clear out active character that may be coming from another mode
    characterPickerStore.state.activeCharacter = undefined;

    // Show mobile alert if on mobile device
    if (isMobile) {
      noticesStore.warning(
        'Pose mode works best on desktop. For a seamless experience, try using a larger screen.',
        10000,
      );
    }

    return () => {
      console.log('PoseMode - Unmount');
    };
  }, [isMobile]);

  useEffect(() => {
    projectStore.loadCurrentProjectGenerationHistory(projectID);
    return projectStore.resetCurrentProject;
  }, [projectID]);

  return (
    <StudioLayout
      player={<PoseMainPlayer />}
      cameraButtons={
        <CameraButtons animationPlayerStore={playerStore} variant="full" />
      }
      prompInput={<PoseFrontDoor />}
      overlays={
        <>
          <FloatPanels />
          <StageLoader /> {/* Legacy component */}
          <VideoOverlay /> {/* Legacy component */}
        </>
      }
      footer={<Footer />}
    />
  );
}
